import { gql } from 'gql/__generated__'

export const editorSectionsTrashCountSubscription = gql(`
    subscription EditorSectionsTrashCountSubscription($projectId: String!) {
      data: editorSectionsTrashCount(projectId: $projectId) {
        count
      }
    }
  `)
